module.exports = __webpack_public_path__ + "img/MASTERCARD.8ca6cc4d.png";